import type { ReactNode } from 'react';

export const symbol_body_fat: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M713-113 88-425q-17.25-8.25-25.12-22.88Q55-462.5 55-478.25q0-15.75 7.88-30.65Q70.75-523.8 88-532l625-312q15.08-8 30.54-6.5Q759-849 772-841t20.5 20.82Q800-807.35 800-790v170h10q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5h-80q-12 0-21-8.68-9-8.67-9-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h10v-168L521-680q32 44 50.5 94.94T590-480q0 56-19 107t-52 96l220 109v-171h-9q-13.08 0-21.54-8.88-8.46-8.87-8.46-22 0-13.12 8.63-21.62 8.62-8.5 21.37-8.5h80q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.91 21.82-8.92 9-22.09 9h-9v172q0 17.35-7.5 30.18Q785-124 772-116t-28.5 9.5Q728-105 713-113ZM464-305q29-38 47.5-82.72Q530-432.45 530-480q0-48-18-91t-47-81L115-479l349 174Z"
		/>
	</svg>
);
